import Contacts from "../app/web/contacts/contacts/contacts.jsx";
import Installer from "../app/web/installer/installer.jsx";
import ChangePassword from "../app/web/change-password/change-password.jsx";
import Sessions from "../app/web/sessions/sessions.jsx";
import SentrygridIndex from "../app/web/gis/sentrygrid-index.jsx";
import DutyInformation from "../app/dispatch/duty-information/duty-information.jsx";
import DashboardWall from "../app/web/dashboard-wall/dashboard-wall.jsx";
import Open from "../app/web/open/open.jsx";
import Home from "../app/web/home/home.jsx";
import Teste from "../app/teste.jsx";
import CorporationForm from "../app/web/corporation/corporation-form.jsx";
import AgentsUserList from "../app/web/agents/user-list/agents-user-list.jsx";
import AgentFormInit from "../app/web/agents/form/agent-form-init.jsx";
import AgentsPersonalList from "../app/web/agents/personal-list/agents-personal-list.jsx";
import AbsencesList from "../app/web/work-schedule/absences/absences-list.jsx";
import AbsenceForm from "../app/web/work-schedule/absences/form/absence-form.jsx";
import HolidayList from "../app/web/work-schedule/holiday/holiday-list.jsx";
import HolidayForm from "../app/web/work-schedule/holiday/form/holiday-form.jsx";
import WorkScheduleList from "../app/web/work-schedule/work-schedule/work-schedule-list.jsx";
import WorkScheduleForm from "../app/web/work-schedule/work-schedule/form/work-schedule-form.jsx";
import WorkScheduleConflicts from "../app/web/work-schedule/work-schedule/form/components/conflicts/work-schedule-conflicts.jsx";
import WorkScheduleBatchConflicts from "../app/web/work-schedule/work-schedule/form/components/conflicts/work-schedule-batch-conflicts.jsx";
import WorkScheduleCalendar from "../app/web/work-schedule/work-schedule/form/components/calendar/work-schedule-calendar.jsx";
import TeamList from "../app/web/team/team-list.jsx";
import TeamForm from "../app/web/team/form/team-form.jsx";
import JourneyList from "../app/web/work-schedule/journey/journey-list.jsx";
import GisIndex from "../app/web/gis/gis-index.jsx";
import AlarmQuestionList from "../app/web/alarm-question/list/alarm-question-list.jsx";
import AlarmQuestionForm from "../app/web/alarm-question/form/alarm-question-form.jsx";
import AutoAssignList from "../app/web/auto-assign/list/auto-assign-list.jsx";
import AutoAssignForm from "../app/web/auto-assign/form/auto-assign-form.jsx";
import AlarmParameters from "../app/web/alarm-parameters/alarm-parameters.jsx";
import NeighborhoodList from "../app/web/neighborhoods/list/neighborhood-list.jsx";
import NeighborhoodForm from "../app/web/neighborhoods/form/neighborhood-form.jsx";
import StreetList from "../app/web/streets/list/street-list.jsx";
import StreetForm from "../app/web/streets/form/street-form.jsx";
import TypePlaceList from "../app/web/type-place/list/type-place-list.jsx";
import TypePlaceForm from "../app/web/type-place/form/type-place-form.jsx";
import PlaceList from "../app/web/place/list/place-list.jsx";
import PlaceForm from "../app/web/place/form/place-form.jsx";
import RuleList from "../app/web/rule/list/rule-list.jsx";
import RuleForm from "../app/web/rule/form/rule-form.jsx";
import NatureList from "../app/web/nature/list/nature-list.jsx";
import NatureForm from "../app/web/nature/form/nature-form.jsx";
import Integrations from "../app/web/integrations/integrations.jsx";
import UserMessages from "../app/web/user-messages/user-messages.jsx";
import MyUser from "../app/web/my-user/my-user.jsx";
import GeoreferencedSearchPage from "../app/web/georeferenced-search/georeferenced-search-page.jsx";
import ConfigObjectList from "../app/web/config-object/list/config-object-list.jsx";
import ConfigObjectForm from "../app/web/config-object/form/config-object-form.jsx";
import OtherDocumentTypeList from "../app/web/other-document-type/list/other-document-type-list.jsx";
import OtherDocumentTypeForm from "../app/web/other-document-type/form/other-document-type-form.jsx";
import ReferralsList from "../app/web/referrals/list/referrals-list.jsx";
import ReferralsForm from "../app/web/referrals/form/referrals-form.jsx";
import ConditionsList from "../app/web/conditions/list/conditions-list.jsx";
import ConditionsForm from "../app/web/conditions/form/conditions-form.jsx";
import AbsenceTypesList from "../app/web/absence-types/absence-types-list.jsx";
import AbsenceTypeForm from "../app/web/absence-types/absence-type-form.jsx";
import LicensingIndex from "../app/web/licensing/licensing-index.jsx";
import StorageStatus from "../app/web/storage-status/storage-status.jsx";
import AssociationNetworkList from "../app/web/association-network/list/association-network-list.jsx";
import AssociationNetworkInit from "../app/web/association-network/form/association-network-init.jsx";
import VideoCamerasList from "../app/web/video-cameras/video-cameras-list.jsx";
import RecordersList from "../app/web/recorders/list/recorders-list.jsx";
import Mosaic from "../app/web/mosaic/mosaic.jsx";
import NotificationVisibilityList from "../app/web/notification/visibility/list/notification-visibility-list.jsx";
import NotificationVisibilityForm from "../app/web/notification/visibility/form/notification-visibility-form.jsx";
import NotificationOpen from "../app/web/notification/open/notification-open.jsx";
import NotificationSigned from "../app/web/notification/signed/notification-signed.jsx";
import BosList from "../app/web/bos/list/bos-list.jsx";
import BoRedirect from "../app/web/bos/redirect/bo-redirect.jsx";
import BoShowIndex from "../app/web/bos/show/bo-show-index.jsx";
import BoFormIndex from "../app/web/bos/form/bo-form-index.jsx";
import BoLastStatus from "../app/web/bos/last-status/bo-last-status.jsx";
import BoUploadOrStart from "../app/web/bos/upload-or-start/bo-upload-or-start.jsx";
import SentryCloud from "../app/web/sentry-cloud/sentry-cloud.jsx";
import ResponsibleMaintenanceList from "../app/web/responsible-maintenance/list/responsible-maintenance-list.jsx";
import ResponsibleMaintenanceForm from "../app/web/responsible-maintenance/form/responsible-maintenance-form.jsx";
import GroupList from "../app/web/group/list/group-list.jsx";
import GroupForm from "../app/web/group/form/group-form.jsx";
import AssetsPlacesList from "../app/web/assets-places/list/assets-places-list.jsx";
import AssetsPlacesForm from "../app/web/assets-places/form/assets-places-form.jsx";
import VehicleClassesList from "../app/web/vehicle-classes/list/vehicle-classes-list.jsx";
import VehicleClassesForm from "../app/web/vehicle-classes/form/vehicle-classes-form.jsx";
import EquipmentsList from "../app/web/equipments/list/equipments-list.jsx";
import EquipmentsForm from "../app/web/equipments/form/equipments-form.jsx";
import AcceptanceRulesList from "../app/web/acceptance-rules/list/acceptance-rules-list.jsx";
import AcceptanceRulesForm from "../app/web/acceptance-rules/form/acceptance-rules-form.jsx";
import PassageLabelsList from "../app/web/passage-labels/list/passage-labels-list.jsx";
import PassageLabelsForm from "../app/web/passage-labels/form/passage-labels-form.jsx";
import PointLayerFormIndex from "../app/web/point-layer/form/point-layer-form-index.jsx";
import PointLayerList from "../app/web/point-layer/list/point-layer-list.jsx";
import AreaLayerFormIndex from "../app/web/area-layer/form/area-layer-form-index.jsx";
import AreaLayerList from "../app/web/area-layer/list/area-layer-list.jsx";
import AdrMonitoringForm from "../app/web/adr-monitoring/form/adr-monitoring-form.jsx";
import AdrMonitoringList from "../app/web/adr-monitoring/list/adr-monitoring-list.jsx";
import AdrCodeForm from "../app/web/adr-code/form/adr-code-form.jsx";
import AdrCodeList from "../app/web/adr-code/list/adr-code-list.jsx";
import ClonesList from "../app/web/clones/list/clones-list.jsx";
import ReviewItems from "../app/web/review-items/list/review-items.jsx";
import ReviewItemsForm from "../app/web/review-items/form/review-items-form.jsx";
import SharedInstitutions from "../app/web/contacts/shared-institutions/shared-institutions.jsx";
import SharedAgents from "../app/web/contacts/shared-agents/shared-agents.jsx";
import OrganizationList from "../app/web/ecap/organization/list/organization-list.jsx";
import OrganizationForm from "../app/web/ecap/organization/form/organization-form.jsx";
import SolicitationList from "../app/web/ecap/solicitation/list/solicitation-list.jsx";
import SolicitationForm from "../app/web/ecap/solicitation/form/solicitation-form.jsx";
import EcapList from "../app/web/ecap/ecap-form/list/ecap-list.jsx";
import EcapForm from "../app/web/ecap/ecap-form/form/ecap-form.jsx";
import EcapTemplate from "../app/web/ecap/ecap-template/ecap-template.jsx";
import InspectionItemsList from "../app/web/inspection-items/list/inspection-items-list.jsx";
import InspectionItemsForm from "../app/web/inspection-items/form/inspection-items-form.jsx";
import AnimalsList from "../app/web/animals/list/animals-list.jsx";
import AnimalsForm from "../app/web/animals/form/animals-form.jsx";
import IndividualMonitoringWatchlist from "../app/web/individual-monitoring-watchlist/list/individual-monitoring-watchlist.jsx";
import IndividualMonitoringWatchlistForm from "../app/web/individual-monitoring-watchlist/form/individual-monitoring-watchlist-form.jsx";
import VehicleNotesList from "../app/web/vehicle-notes/list/vehicle-notes-list.jsx";
import VehicleNotesForm from "../app/web/vehicle-notes/form/vehicle-notes-form.jsx";
import Download from "../app/web/download/download.jsx";
import Backup from "../app/web/backup/backup.jsx";
import AssetActivesList from "../app/web/assets-actives/list/asset-actives-list.jsx";
import AssetActivesForm from "../app/web/assets-actives/form/asset-actives-form.jsx";
import AssetTransferList from "../app/web/assets-transfer/list/asset-transfer-list.jsx";
import AssetTransferForm from "../app/web/assets-transfer/form/asset-transfer-form.jsx";
import ImageValidator from "../app/web/image-validator/image-validator.jsx";
import NocCamerasList from "../app/web/noc-cameras/list/noc-cameras-list.jsx";
import NocSmartcapturesList from "../app/web/noc-smartcaptures/list/noc-smartcaptures-list.jsx";
import Smartcaptures from "../app/web/smartcaptures/form/smartcaptures.jsx";
import ContactIdList from "../app/web/contact-id/list/contact-id-list.jsx";
import ContactIdForm from "../app/web/contact-id/form/contact-id-form.jsx";
import ContactIdEventsList from "../app/web/contact-id-events/list/contact-id-events-list.jsx";
import ContactIdEventTypesList from "../app/web/contact-id-types/list/contact-id-event-types-list.jsx";
import RouteList from "../app/web/routes/list/route-list.jsx";
import RouteForm from "../app/web/routes/form/route-form.jsx";
import CapturePlacesList from "../app/web/capture-places/list/capture-places-list.jsx";
import CapturePlacesForm from "../app/web/capture-places/form/capture-places-form.jsx";
import Compression from "../app/web/compression/compression.jsx";
import AnalysisToolIndex from "../app/web/analysis-tool/analysis-tool-index.jsx";
import LaneAliasList from "../app/web/lane-alias/list/lane-alias-list.jsx";
import LaneAliasForm from "../app/web/lane-alias/form/lane-alias-form.jsx";
import FtpUserList from "../app/web/ftp-user/list/ftp-user-list.jsx";
import FtpUserForm from "../app/web/ftp-user/form/ftp-user-form.jsx";
import JanitorialList from "../app/web/janitorial/list/janitorial-list.jsx";
import JanitorialForm from "../app/web/janitorial/form/janitorial-form.jsx";
import UsageRecord from "../app/web/usage-record/list/usage-record.jsx";
import UsageRecordForm from "../app/web/usage-record/form/usage-record-form.jsx";
import RoleList from "../app/web/role/list/role-list.jsx";
import RoleIndex from "../app/web/role/form/role-index.jsx";
import DeviceList from "../app/web/device/list/device-list.jsx";
import DeviceForm from "../app/web/device/form/device-form.jsx";
import VehiclesList from "../app/web/vehicles/vehicle-list/vehicles-list.jsx";
import VehiclesForm from "../app/web/vehicles/vehicle-form/vehicles-form.jsx";
import ReferenceVehicleList from "../app/web/reference-vehicle/list/reference-vehicle-list.jsx";
import ReferenceVehicleForm from "../app/web/reference-vehicle/form/reference-vehicle-form.jsx";
import CortexRenavam from "../app/web/cortex-renavam/cortex-renavam.jsx";
import CeleparRenavam from "../app/web/celepar/renavam/celepar-renavam.jsx";
import CeleparDriver from "../app/web/celepar/driver/celepar-driver.jsx";
import CortexSearch from "../app/web/cortex-search/cortex-search.jsx";
import SentryCloudSearch from "../app/web/sentry-cloud-search/sentry-cloud-search.jsx";
import SuppliesList from "../app/web/supplies/list/supplies-list.jsx";
import SuppliesForm from "../app/web/supplies/form/supplies-form.jsx";
import MaintenancesList from "../app/web/maintenances/list/maintenances-list.jsx";
import MaintenancesForm from "../app/web/maintenances/form/maintenances-form.jsx";
import CorporationSearchList from "../app/web/corporation-search/list/corporation-search-list.jsx";
import MapSelection from "../app/web/map-selection/map-selection.jsx";
import EncounterList from "../app/web/encounter/list/encounter-list.jsx";
import EncounterForm from "../app/web/encounter/form/encounter-form.jsx";
import EncounterEdit from "../app/web/encounter/edit/encounter-edit.jsx";
import Lanes from "../app/web/lanes/lanes.jsx";
import Library from "../app/web/library/library.jsx";
import LibraryDocumentForm from "../app/web/library/sentry-doc/library-document-form.jsx";
import IndividualList from "../app/web/individual/list/individual-list.jsx";
import IndividualIndex from "../app/web/individual/form/individual-index.jsx";
import IndividualPassageSearch from "../app/web/individual-passage-search/individual-passage-search.jsx";
import IndividualAlarm from "../app/web/individual-alarm/individual-alarm.jsx";
import IndividualMonitoringList from "../app/web/individual-monitoring/individual-monitoring-list.jsx";
import IndividualMonitoringForm from "../app/web/individual-monitoring/form/individual-monitoring-form.jsx";
import SentryPhoneSettings from "../app/web/sentry-phone/sentry-phone-settings.jsx";
import SentryPhoneCalls from "../app/web/sentry-phone/sentry-phone-calls.jsx";
import BosTags from "../app/web/bos-tags/list/bos-tags.jsx";
import BosTagsForm from "../app/web/bos-tags/form/bos-tags-form.jsx";
import DashboardWall2 from "../app/web/dashboard-wall/./dashboard-wall.jsx";
import {createBrowserRouter} from "react-router";
import Login from "../app/web/login/login.jsx";
import RouterReports from "./router-reports.js";
import RouterMaterials from "./router-materials.js";
import {protectedLoader, isLogged, requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";
import RouterDispatch from "./router-dispatch.js";
import Unauthorized from "../app/errors/unauthorized.jsx";
import NotFound from "../app/errors/not-found.jsx";
import ErrorPage from "../app/errors/error-page.jsx";
import RouterSos from "./router-sos.js";
import AppShell from "../app/app-shell/app-shell.jsx";
import Loader from "../components/template/loader.jsx";
import RouterDev from "./router-dev.js";
import DashboardSos from "../app/web/sos/dashboard-sos/dashboard-sos.jsx";

const PERSONAL_AGENTS = [
    PermissionEnum.USER_DOCUMENTS,
    PermissionEnum.USER_TRAININGS,
    PermissionEnum.USER_CONDUCT_HISTORY,
    PermissionEnum.USER_ABSENCES,
    PermissionEnum.USER_CLOTHES,
    PermissionEnum.USER_DEPENDENTS,
    PermissionEnum.SKILLS_RESTRICTIONS,
];
const ALARM = [PermissionEnum.ALARM_CONFIGURATIONS, PermissionEnum.ALARM_INACTIVATE];
const ADDRESSES = [PermissionEnum.ADDRESSES_ADMIN, PermissionEnum.ERP_JANITORIAL];
const CONTACTID = [PermissionEnum.CONTACTID, PermissionEnum.CONTACTID_ADMIN];
const ANALYSIS_TOOL = [PermissionEnum.GEOREF, PermissionEnum.OCCURRENCE];
const CORPORATION_SEARCH = [PermissionEnum.PASSAGE_SEARCH, PermissionEnum.PASSAGE_SEARCH_GEOREF];
const BASENAME = import.meta.env.BASE_URL;

const router = createBrowserRouter([
    {path: "/*", Component: NotFound},
    {path: "/401", Component: Unauthorized},
    {
        id: "contacts",
        path: "/contacts",
        HydrateFallback: Loader,
        Component: Contacts
    },
    {
        id: "installer",
        path: "/installer",
        HydrateFallback: Loader,
        Component: Installer
    },
    {id: "login", path: "/", Component: Login, loader: isLogged},
    {id: "reset-password", path: "/reset-password/:login", Component: Login, loader: isLogged},
    {
        id: "change-password",
        path: "/change-password",
        HydrateFallback: Loader,
        Component: ChangePassword,
        loader: protectedLoader
    },
    {
        id: "admin-session",
        path: "/admin-session",
        HydrateFallback: Loader,
        Component: Sessions,
        loader: requirePermission(PermissionEnum.CONFIGURATION)
    },
    {
        id: "sentrygrid-gis",
        path: "/sentrygrid/gis",
        HydrateFallback: Loader,
        Component: SentrygridIndex,
        loader: requirePermission(PermissionEnum.GIS)
    },
    {
        id: "sentrygrid",
        path: "/sentrygrid/dutyInformation",
        HydrateFallback: Loader,
        Component: DutyInformation,
        loader: requirePermission(PermissionEnum.DUTY_INFORMATION)
    },
    {
        id: "sentrygrid-wall",
        path: "/sentrygrid/sentry-wall",
        HydrateFallback: Loader,
        Component: DashboardWall,
        loader: requirePermission(PermissionEnum.DASHBOARD_WALL),
    },
    {
        id: "sentrygrid-sos",
        path: "/sentrygrid/dashboard-sos",
        HydrateFallback: Loader,
        Component: DashboardSos,
        loader: requirePermission(PermissionEnum.SOS_DASHBOARD),
    },
    {
        id: "open-from-idk",
        path: "/open/:uuid",
        Component: Open,
    },
    {
        Component: AppShell,
        ErrorBoundary: ErrorPage,
        HydrateFallback: Loader,
        children: [
            {
                id: "home",
                path: "/home",
                Component: Home,
                loader: protectedLoader
            },
            {
                id: "teste",
                path: "/teste",
                Component: Teste,
                loader: protectedLoader
            },
            {path: "/reports", children: RouterReports()},
            {path: "/materials", children: RouterMaterials()},
            {path: "/despacho", children: RouterDispatch(requirePermission(PermissionEnum.DISPATCH))},
            {path: "/sos", children: RouterSos()},
            {path: "/dev", children: RouterDev()},
            {
                id: "corporation",
                path: "/corporation",
                Component: CorporationForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "user-agents",
                path: "/user-agents",
                Component: AgentsUserList,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "user-agents-form",
                path: "/user-agents/form/:id?",
                Component: AgentFormInit,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "personal-agents",
                path: "/personal-agents",
                Component: AgentsPersonalList,
                loader: requirePermission(PERSONAL_AGENTS)
            },
            {
                id: "personal-agents-form",
                path: "/personal-agents/form/:id?",
                Component: AgentFormInit,
                loader: requirePermission(PERSONAL_AGENTS)
            },
            {
                id: "absences",
                path: "absences",
                Component: AbsencesList,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "absences-form",
                path: "/absences/form/:id?",
                Component: AbsenceForm,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "holiday",
                path: "/holiday",
                Component: HolidayList,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "holiday-form",
                path: "/holiday/form/:id?",
                Component: HolidayForm,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "work-schedule",
                path: "/work-schedule",
                Component: WorkScheduleList,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "work-schedule-form",
                path: "/work-schedule/form/:id?",
                Component: WorkScheduleForm,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "work-schedule-conflicts",
                path: "/work-schedule/conflicts/:id?",
                Component: WorkScheduleConflicts,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "work-schedule-batch-conflicts",
                path: "/work-schedule/batch-conflicts/:id?",
                Component: WorkScheduleBatchConflicts,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "work-schedule-calendar",
                path: "/work-schedule/calendar/:id?",
                Component: WorkScheduleCalendar,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "team",
                path: "/team",
                Component: TeamList,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "team-form",
                path: "/team/form/:id?",
                Component: TeamForm,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "journey",
                path: "/journey",
                Component: JourneyList,
                loader: requirePermission(PermissionEnum.ERP_PERSONAL)
            },
            {
                id: "gis",
                path: "/gis",
                Component: GisIndex,
                loader: requirePermission(PermissionEnum.GIS)
            },
            {
                id: "alarm-question",
                path: "/alarm-question",
                Component: AlarmQuestionList,
                loader: requirePermission(ALARM)
            },
            {
                id: "alarm-question-form",
                path: "/alarm-question/form/:id?",
                Component: AlarmQuestionForm,
                loader: requirePermission(ALARM)
            },
            {
                id: "auto-assign",
                path: "/auto-assign",
                Component: AutoAssignList,
                loader: requirePermission(ALARM)
            },
            {
                id: "auto-assign-form",
                path: "/auto-assign/form/:id?",
                Component: AutoAssignForm,
                loader: requirePermission(ALARM)
            },
            {
                id: "alarm-parameters",
                path: "/alarm-parameters",
                Component: AlarmParameters,
                loader: requirePermission(ALARM)
            },
            {
                id: "neighborhood-list",
                path: "/neighborhood",
                Component: NeighborhoodList,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "neighborhood-form",
                path: "/neighborhood/form/:id?",
                Component: NeighborhoodForm,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "street-list",
                path: "/street",
                Component: StreetList,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "street-form",
                path: "/street/form/:id?",
                Component: StreetForm,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "type-place-list",
                path: "/typePlace",
                Component: TypePlaceList,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "type-place-form",
                path: "/typePlace/form/:id?",
                Component: TypePlaceForm,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "place-list",
                path: "/place",
                Component: PlaceList,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "place-form",
                path: "/place/form/:id?",
                Component: PlaceForm,
                loader: requirePermission(ADDRESSES)
            },
            {
                id: "rule",
                path: "/rule",
                Component: RuleList,
                loader: requirePermission(PermissionEnum.MOBILE_ALARM_RULES_ADMIN)
            },
            {
                id: "rule-form",
                path: "/rule-form/:id?",
                Component: RuleForm,
                loader: requirePermission(PermissionEnum.MOBILE_ALARM_RULES_ADMIN)
            },
            {
                id: "nature",
                path: "/nature",
                Component: NatureList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "nature-form",
                path: "/nature/form/:id?",
                Component: NatureForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "integrations",
                path: "/integrations",
                Component: Integrations,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "user-messages",
                path: "/user-messages",
                Component: UserMessages,
                loader: protectedLoader
            },
            {
                id: "my-user",
                path: "/my-user",
                Component: MyUser,
                loader: protectedLoader
            },
            {
                id: "georeferencedSearch",
                path: "/georeferencedSearch",
                Component: GeoreferencedSearchPage,
                loader: requirePermission(PermissionEnum.PASSAGE_SEARCH_GEOREF)
            },
            {
                id: "config-object",
                path: "/objects",
                Component: ConfigObjectList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "config-object-form",
                path: "/objects/form/:id?",
                Component: ConfigObjectForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "other-document-type",
                path: "/otherDocumentTypes",
                Component: OtherDocumentTypeList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "other-document-type-form",
                path: "/otherDocumentTypes/form/:id?",
                Component: OtherDocumentTypeForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "referrals",
                path: "/referrals",
                Component: ReferralsList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "referrals-form",
                path: "/referrals/form/:id?",
                Component: ReferralsForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "conditions",
                path: "/conditions",
                Component: ConditionsList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "conditions-form",
                path: "/conditions/form/:id?",
                Component: ConditionsForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "absence-types",
                path: "/absence-types",
                Component: AbsenceTypesList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "absence-types-form",
                path: "/absence-types/form/:id?",
                Component: AbsenceTypeForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "licensing",
                path: "/licensing",
                Component: LicensingIndex,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "storage-status",
                path: "/storage-status",
                Component: StorageStatus,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "association-network",
                path: "/association-network",
                Component: AssociationNetworkList,
                loader: requirePermission(PermissionEnum.ANALYSIS_NETWORK)
            },
            {
                id: "association-network-form",
                path: "/association-network/form/:id?",
                Component: AssociationNetworkInit,
                loader: requirePermission(PermissionEnum.ANALYSIS_NETWORK)
            },
            {
                id: "video-cameras",
                path: "/video-cameras",
                Component: VideoCamerasList,
                loader: requirePermission(PermissionEnum.VIDEO_CAMERA)
            },
            {
                id: "recorders",
                path: "/recorders",
                Component: RecordersList,
                loader: requirePermission(PermissionEnum.VIDEO_CAMERA)
            },
            {
                id: "mosaic",
                path: "/mosaic",
                Component: Mosaic,
                loader: protectedLoader
            },
            {
                id: "notifications-visibility",
                path: "/notifications-visibility",
                Component: NotificationVisibilityList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "notifications-visibility-form",
                path: "/notifications-visibility/form/:id?",
                Component: NotificationVisibilityForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "notifications-open",
                path: "/notifications-open",
                Component: NotificationOpen,
                loader: protectedLoader
            },
            {
                id: "notifications-signed",
                path: "/notifications-signed",
                Component: NotificationSigned,
                loader: protectedLoader
            },
            {
                id: "bos",
                path: "/bos",
                Component: BosList,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "bo-redirect",
                path: "/bo/redirect/:id?",
                Component: BoRedirect,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "bo-show",
                path: "/bo/show/:id?",
                Component: BoShowIndex,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "bo-form",
                path: "/bo/form/:id?/:sync?",
                Component: BoFormIndex,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "bo-last-status",
                path: "/bo/last-status/:id?",
                Component: BoLastStatus,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "bo-upload-or-start",
                path: "/bo/:id?",
                Component: BoUploadOrStart,
                loader: requirePermission(PermissionEnum.BOGCM_WEB)
            },
            {
                id: "sentry-cloud",
                path: "/sentry-cloud",
                Component: SentryCloud,
                loader: requirePermission(PermissionEnum.SENTRY_CLOUD)
            },
            {
                id: "responsible-maintenance",
                path: "/responsible-maintenance",
                Component: ResponsibleMaintenanceList,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "responsible-maintenance-form",
                path: "/responsible-maintenance/form/:id?",
                Component: ResponsibleMaintenanceForm,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "sessions",
                path: "/sessions",
                Component: Sessions,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "group",
                path: "/group",
                Component: GroupList,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "group-form",
                path: "/group/form/:id?",
                Component: GroupForm,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "asset-places",
                path: "/asset-places",
                Component: AssetsPlacesList,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "asset-places-form",
                path: "/asset-places/form/:id?",
                Component: AssetsPlacesForm,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "vehicle-classes",
                path: "/vehicle-classes",
                Component: VehicleClassesList,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "vehicle-classes-form",
                path: "/vehicle-classes/form/:id?",
                Component: VehicleClassesForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "equipments",
                path: "/equipments",
                Component: EquipmentsList,
                loader: requirePermission(PermissionEnum.ERP_JANITORIAL)
            },
            {
                id: "equipments-form",
                path: "/equipments/form/:id?",
                Component: EquipmentsForm,
                loader: requirePermission(PermissionEnum.ERP_JANITORIAL)
            },
            {
                id: "acceptance-rules",
                path: "/acceptance-rules",
                Component: AcceptanceRulesList,
                loader: requirePermission(PermissionEnum.SENTRY_CLOUD)
            },
            {
                id: "acceptance-rules-form",
                path: "/acceptance-rules/form/:id?",
                Component: AcceptanceRulesForm,
                loader: requirePermission(PermissionEnum.SENTRY_CLOUD)
            },
            {
                id: "passage-labels",
                path: "/passage-labels",
                Component: PassageLabelsList,
                loader: requirePermission(PermissionEnum.PASSAGE_LABEL)
            },
            {
                id: "passage-labels-form",
                path: "/passage-labels/form/:id?",
                Component: PassageLabelsForm,
                loader: requirePermission(PermissionEnum.PASSAGE_LABEL)
            },
            {
                id: "point-layer-form",
                path: "/point-layer/form/:id?",
                Component: PointLayerFormIndex,
                loader: requirePermission(PermissionEnum.GEOREF_ADMIN)
            },
            {
                id: "point-layer",
                path: "/point-layer",
                Component: PointLayerList,
                loader: requirePermission(PermissionEnum.GEOREF_ADMIN)
            },
            {
                id: "area-layer-form",
                path: "/area-layer/form/:id?",
                Component: AreaLayerFormIndex,
                loader: requirePermission(PermissionEnum.GEOREF_ADMIN)
            },
            {
                id: "area-layer",
                path: "/area-layer",
                Component: AreaLayerList,
                loader: requirePermission(PermissionEnum.GEOREF_ADMIN)
            },
            {
                id: "products-monitoring-form",
                path: "/adr-monitoring/form/:id?",
                Component: AdrMonitoringForm,
                loader: requirePermission(PermissionEnum.ADR_MONITORING)
            },
            {
                id: "products-monitoring",
                path: "/adr-monitoring",
                Component: AdrMonitoringList,
                loader: requirePermission(PermissionEnum.ADR_MONITORING)
            },
            {
                id: "adr-code-form",
                path: "/adr-code/form/:id?",
                Component: AdrCodeForm,
                loader: requirePermission(PermissionEnum.ADR_CODE)
            },
            {
                id: "adr-code",
                path: "/adr-code",
                Component: AdrCodeList,
                loader: requirePermission(PermissionEnum.ADR_CODE)
            },
            {
                id: "clones",
                path: "/clones",
                Component: ClonesList,
                loader: requirePermission(PermissionEnum.SENTRY_CLONE)
            },
            {
                id: "review-items",
                path: "/review-items",
                Component: ReviewItems,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "review-items-form",
                path: "/review-items/form/:id?",
                Component: ReviewItemsForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "shared-institutions",
                path: "/shared-institutions",
                Component: SharedInstitutions,
                loader: protectedLoader
            },
            {
                id: "shared-agents",
                path: "/shared-agents",
                Component: SharedAgents,
                loader: protectedLoader
            },
            {
                id: "ecap-organization",
                path: "/ecap-organization",
                Component: OrganizationList,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "ecap-organization-form",
                path: "/ecap-organization/form/:id?",
                Component: OrganizationForm,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "ecap-solicitation",
                path: "/ecap-solicitation",
                Component: SolicitationList,
                loader: requirePermission(PermissionEnum.ECAP)
            },
            {
                id: "ecap-solicitation-form",
                path: "/ecap-solicitation/form/:id?",
                Component: SolicitationForm,
                loader: requirePermission(PermissionEnum.ECAP)
            },
            {
                id: "ecap",
                path: "/ecap",
                Component: EcapList,
                loader: requirePermission(PermissionEnum.ECAP)
            },
            {
                id: "ecap-form",
                path: "/ecap/form/:id?",
                Component: EcapForm,
                loader: requirePermission(PermissionEnum.ECAP)
            },
            {
                id: "ecap-template",
                path: "/ecap-template/form/:id?",
                Component: EcapTemplate,
                loader: requirePermission(PermissionEnum.ECAP)
            },
            {
                id: "inspection-items",
                path: "/inspection-items",
                Component: InspectionItemsList,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "inspection-items-form",
                path: "/inspection-items/form/:id?",
                Component: InspectionItemsForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "animals",
                path: "/animals",
                Component: AnimalsList,
                loader: requirePermission(PermissionEnum.ERP_ANIMALS)
            },
            {
                id: "animals-form",
                path: "/animals/form/:id?",
                Component: AnimalsForm,
                loader: requirePermission(PermissionEnum.ERP_ANIMALS)
            },
            {
                id: "individual-monitoring-watchlist",
                path: "/individual-monitoring-watchlist",
                Component: IndividualMonitoringWatchlist,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_MONITORING)
            },
            {
                id: "individual-monitoring-watchlist-form",
                path: "/individual-monitoring-watchlist/form/:id?",
                Component: IndividualMonitoringWatchlistForm,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_MONITORING)
            },
            {
                id: "vehicle-notes",
                path: "/vehicle-notes",
                Component: VehicleNotesList,
                loader: requirePermission(PermissionEnum.REFERENCE_VEHICLES_NOTES)
            },
            {
                id: "vehicle-notes-form",
                path: "/vehicle-notes/form/:id?",
                Component: VehicleNotesForm,
                loader: requirePermission(PermissionEnum.REFERENCE_VEHICLES_NOTES)
            },
            {
                id: "download",
                path: "/download",
                Component: Download,
                loader: protectedLoader
            },
            {
                id: "backup",
                path: "/backup",
                Component: Backup,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "asset-actives",
                path: "/asset-actives",
                Component: AssetActivesList,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "asset-actives-form",
                path: "/asset-actives/form/:id?",
                Component: AssetActivesForm,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "asset-transfer",
                path: "/asset-transfer",
                Component: AssetTransferList,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "asset-transfer-form",
                path: "/asset-transfer/form/:id?",
                Component: AssetTransferForm,
                loader: requirePermission(PermissionEnum.ERP_ASSET)
            },
            {
                id: "image-validator",
                path: "/image-validator",
                Component: ImageValidator,
                loader: protectedLoader
            },
            {
                id: "noc-cameras",
                path: "/noc-cameras",
                Component: NocCamerasList,
                loader: requirePermission(PermissionEnum.NOC)
            },
            {
                id: "noc-smartcaptures",
                path: "/noc-smartcaptures",
                Component: NocSmartcapturesList,
                loader: requirePermission(PermissionEnum.NOC)
            },
            {
                id: "smartcaptures",
                path: "/smartcaptures/form/:pin?",
                Component: Smartcaptures,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "contact-id-list",
                path: "/contact-id",
                Component: ContactIdList,
                loader: requirePermission(CONTACTID)
            },
            {
                id: "contact-id-form",
                path: "/contact-id/form/:id?",
                Component: ContactIdForm,
                loader: requirePermission(CONTACTID)
            },
            {
                id: "contact-id-events-list",
                path: "/contact-id-events/:mode/:id",
                Component: ContactIdEventsList,
                loader: requirePermission(CONTACTID)
            },
            {
                id: "contact-id-event-types-list",
                path: "/contact-id-event-types",
                Component: ContactIdEventTypesList,
                loader: requirePermission(PermissionEnum.CONTACTID_ADMIN)
            },
            {
                id: "route",
                path: "/route",
                Component: RouteList,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "route-form",
                path: "/route/form/:id?",
                Component: RouteForm,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "capture-places",
                path: "/capture-places",
                Component: CapturePlacesList,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "capture-places-form",
                path: "/capture-places/form/:id?",
                Component: CapturePlacesForm,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "compression",
                path: "/compression",
                Component: Compression,
                loader: requirePermission(PermissionEnum.CONFIGURATION)
            },
            {
                id: "analysis-tool",
                path: "/analysis-tool",
                Component: AnalysisToolIndex,
                loader: requirePermission(ANALYSIS_TOOL)
            },
            {
                id: "lane-alias",
                path: "/lane-alias",
                Component: LaneAliasList,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "lane-alias-form",
                path: "/lane-alias/form/:id?",
                Component: LaneAliasForm,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "ftp-users",
                path: "/ftp-users",
                Component: FtpUserList,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "ftp-users-form",
                path: "/ftp-users/form/:id",
                Component: FtpUserForm,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "janitorial",
                path: "/janitorial",
                Component: JanitorialList,
                loader: requirePermission(PermissionEnum.ERP_JANITORIAL)
            },
            {
                id: "janitorial-form",
                path: "/janitorial/form/:id?",
                Component: JanitorialForm,
                loader: requirePermission(PermissionEnum.ERP_JANITORIAL)
            },
            {
                id: "usage-record",
                path: "/usage-record",
                Component: UsageRecord,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "usage-record-form",
                path: "/usage-record/form/:id?",
                Component: UsageRecordForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "role",
                path: "/role",
                Component: RoleList,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "role-form",
                path: "/role/form/:id?",
                Component: RoleIndex,
                loader: requirePermission(PermissionEnum.USER)
            },
            {
                id: "device",
                path: "/device",
                Component: DeviceList,
                loader: requirePermission(PermissionEnum.MOBILE_ALARM_RULES_ADMIN)
            },
            {
                id: "device-form",
                path: "/device/form/:id?",
                Component: DeviceForm,
                loader: requirePermission(PermissionEnum.MOBILE_ALARM_RULES_ADMIN)
            },
            {
                id: "vehicles",
                path: "/vehicles",
                Component: VehiclesList,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "vehicles-form",
                path: "/vehicles/form/:id?",
                Component: VehiclesForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "reference-vehicle",
                path: "/vehicle",
                Component: ReferenceVehicleList,
                loader: requirePermission(PermissionEnum.REFERENCE_VEHICLE)
            },
            {
                id: "reference-vehicle-form",
                path: "/vehicle/form/:id?",
                Component: ReferenceVehicleForm,
                loader: requirePermission(PermissionEnum.REFERENCE_VEHICLE)
            },
            {
                id: "cortex-renavam",
                path: "/cortex-renavam",
                Component: CortexRenavam,
                loader: requirePermission(PermissionEnum.CORTEX_RENAVAM)
            },
            {
                id: "celepar-renavam",
                path: "/celepar-renavam",
                Component: CeleparRenavam,
                loader: requirePermission(PermissionEnum.CELEPAR_RENAVAM)
            },
            {
                id: "celepar-driver",
                path: "/celepar-driver",
                Component: CeleparDriver,
                loader: requirePermission(PermissionEnum.CELEPAR_DRIVER)
            },
            {
                id: "cortex-search",
                path: "/cortex-search",
                Component: CortexSearch,
                loader: requirePermission(PermissionEnum.CORTEX_PASSAGES)
            },
            {
                id: "sentry-cloud-search",
                path: "/sentry-cloud-search",
                Component: SentryCloudSearch,
                loader: requirePermission(PermissionEnum.PASSAGE_SEARCH_SENTRYCLOUD)
            },
            {
                id: "supplies",
                path: "/supplies",
                Component: SuppliesList,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "supplies-form",
                path: "/supplies/form/:id?",
                Component: SuppliesForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "maintenances",
                path: "/maintenances",
                Component: MaintenancesList,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "maintenances-form",
                path: "/maintenances/form/:id?",
                Component: MaintenancesForm,
                loader: requirePermission(PermissionEnum.ERP_FLEET)
            },
            {
                id: "corporation-search",
                path: "/corporation-search",
                Component: CorporationSearchList,
                loader: requirePermission(CORPORATION_SEARCH)
            },
            {
                id: "map-selection",
                path: "/map-selection",
                Component: MapSelection,
                loader: protectedLoader,
                handle: {hideMenu: true}
            },
            {
                id: "encounter",
                path: "/encounter",
                Component: EncounterList,
                loader: requirePermission(PermissionEnum.ENCOUNTER)
            },
            {
                id: "encounter-form",
                path: "/encounter/form/:id?",
                Component: EncounterForm,
                loader: requirePermission(PermissionEnum.ENCOUNTER)
            },
            {
                id: "encounter-edit",
                path: "/encounter/form/:id?/edit",
                Component: EncounterEdit,
                loader: requirePermission(PermissionEnum.ENCOUNTER)
            },
            {
                id: "lanes",
                path: "/lanes",
                Component: Lanes,
                loader: requirePermission(PermissionEnum.CAPTURE_PLACE)
            },
            {
                id: "library",
                path: "/library",
                Component: Library,
                loader: protectedLoader
            },
            {
                id: "library-document-form",
                path: "/library/document/form/:id?",
                Component: LibraryDocumentForm,
                loader: protectedLoader
            },
            {
                id: "individuals",
                path: "/individuals",
                Component: IndividualList,
                loader: requirePermission(PermissionEnum.REFERENCE_INDIVIDUAL)
            },
            {
                id: "individuals-form",
                path: "/individuals/form/:cpf?",
                Component: IndividualIndex,
                loader: requirePermission(PermissionEnum.REFERENCE_INDIVIDUAL)
            },
            {
                id: "individual-passage-search",
                path: "/individual-passage-search",
                Component: IndividualPassageSearch,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_PASSAGE_SEARCH)
            },
            {
                id: "individual-alarm",
                path: "/individual-alarm",
                Component: IndividualAlarm,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_ALARM)
            },
            {
                id: "individual-monitoring",
                path: "/individual-monitoring",
                Component: IndividualMonitoringList,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_MONITORING)
            },
            {
                id: "individual-monitoring-form",
                path: "/individual-monitoring/form/:id?",
                Component: IndividualMonitoringForm,
                loader: requirePermission(PermissionEnum.INDIVIDUAL_MONITORING)
            },
            {
                id: "sentry-phone-settings",
                path: "/sentry-phone-settings",
                Component: SentryPhoneSettings,
                loader: requirePermission(PermissionEnum.SENTRY_PHONE_CONFIG)
            },
            {
                id: "sentry-phone-calls",
                path: "/sentry-phone-calls/:sipUser?",
                Component: SentryPhoneCalls,
                loader: requirePermission(PermissionEnum.SENTRY_PHONE_CALL_LOG)
            },
            {
                id: "bos-tags",
                path: "/bos-tags",
                Component: BosTags,
                loader: requirePermission(PermissionEnum.BOGCM_TAGS),
            },
            {
                id: "form",
                path: "/bos-tags/form/:id?",
                Component: BosTagsForm,
                loader: requirePermission(PermissionEnum.BOGCM_TAGS),
            },
            {
                id: "dashboard-wall",
                path: "/sentry-wall",
                Component: DashboardWall2,
                loader: requirePermission(PermissionEnum.DASHBOARD_WALL)
            },
        ],
    },
], {basename: BASENAME});

export default router;
